// extracted by css-extract-rspack-plugin
export default {"vSeparator":"v-separator--EAqAQ53RKwT_lw4R"};